<template>
  <HPopup class="h-mode-free"
          ref="popup"
          :closeOnClickModal="false"
          :visible.sync="visible">
    <PanelList
      v-if="!configEditShow"
      @buildConfig="handleBuildConfig"
      @editConfig="handleEditConfig"
      @close="handleClose"
      @apply="handleApply">
    </PanelList>
    <PanelConfig
      v-else
      :editData="editData"
      @close="configEditShow=false"
      @apply="handleApply">
    </PanelConfig>

  </HPopup>
</template>

<script>
  import HPopup from '@/components/h-popup/index'
  import PanelList from './panel-list/panel-list'
  import PanelConfig from './panel-config/index'
  import API from '@js/api'

  export default {
    name: 'h-mode-free',

    data () {
      return {
        configEditShow: false,
        editData: null,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
    },

    computed: {},

    mounted () {
    },

    methods: {
      handleBuildConfig () {
        this.editData = null
        this.configEditShow = true
      },

      handleEditConfig (data) {
        this.editData = data
        this.$nextTick(() => {
          this.configEditShow = true
        })
      },

      handleApply (data) {
        this.$emit('select', data)
      },

      handleClose () {
        this.$emit('close')
      },
    },

    components: {
      HPopup,
      PanelList,
      PanelConfig,
    }

  }
</script>

<style lang="stylus" scoped>
  .h-popup.h-mode-free /deep/ .h-popup-container /*position absolute
    left auto
    right 0
    top 0*/
    padding 15px 15px 20px
    width 900px
    height 550px

  /*transform translate(0, 0)*/

  .h-mode-free
    /deep/ .h-popup-container
      font-size 12px


</style>
